import { site } from "@/mocks/site";
import SectionHeading from "@/components/base/SectionHeading";

const voices = [
  {
    user: "睡前刷十分钟",
    role: "老用户 · 追热点型",
    content:
      "以前要在好几个平台来回翻，现在打开榜单从第一看到第十，基本就知道今天发生了什么，省事很多。",
  },
  {
    user: "理性围观派",
    role: "活跃评论者",
    content:
      "比较喜欢它的分类，我可以直接跳过不感兴趣的方向，只看影视和生活两块，节奏刚好。",
  },
  {
    user: "写周报的小陈",
    role: "内容从业者",
    content:
      "做选题的时候会先来扫一眼榜单，热度值和涨跌标注很直观，能快速判断哪些是还在爬升的话题。",
  },
];

const stats = [
  { value: "128", label: "在榜话题", icon: "ri-list-check-2" },
  { value: "15", label: "更新间隔（分钟）", icon: "ri-timer-flash-line" },
  { value: "6", label: "内容频道", icon: "ri-layout-grid-line" },
  { value: "24h", label: "反馈处理时长", icon: "ri-customer-service-2-line" },
];

export default function VoiceSection() {
  return (
    <section id="voice" className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="网站口碑"
          title="围观的人是怎么用这份榜单的"
          desc={`${site.name} 更想做一个“看得清楚”的榜，而不是把信息堆给你。下面是几位常来围观的用户留下的真实感受。`}
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {voices.map((item) => (
            <figure
              key={item.user}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-double-quotes-l text-lg"></i>
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                  {item.user.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="font-label text-sm font-semibold text-foreground-900">
                    {item.user}
                  </span>
                  <span className="text-xs font-label text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <dl className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-xl font-bold text-foreground-950">
                  {item.value}
                </span>
                <span className="text-xs font-label text-foreground-500">{item.label}</span>
              </span>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}